import { z } from 'zod'
import type { Hex } from '../../types'
import type { TransactionIndex } from '../../types/transactionIndex'
import type { KaiascanClient } from './client'
import { kaiascanTransactionSchema } from './schema'

type GetTransactionsByAddressParameters = {
  client: KaiascanClient
  address: Hex
  startblock?: number
  endblock?: number
  page?: number
  offset?: number
  sort?: 'asc' | 'desc'
  headers?: Record<string, string>
}

const resultSchema = z.array(kaiascanTransactionSchema)

/**
 * Kaiascan から address の normal transaction 一覧を取得する。
 *
 * @param parameters - client、address、block range、pagination、headers。
 * @returns transaction index の配列。
 */
export const getTransactionsByAddress = async ({
  client,
  address,
  startblock = 0,
  endblock,
  page = 1,
  offset = 500,
  sort = 'asc',
  headers,
}: GetTransactionsByAddressParameters): Promise<TransactionIndex[]> => {
  try {
    const result = await client.get({
      path: '',
      query: {
        module: 'account',
        action: 'txlist',
        address,
        startblock: startblock.toString(),
        ...(endblock === undefined ? {} : { endblock: endblock.toString() }),
        page: page.toString(),
        offset: offset.toString(),
        sort,
      },
      resultSchema,
      headers,
    })
    return result.map((transaction) => ({
      blockNumber: transaction.blockNumber,
      hash: transaction.hash,
      timestamp: transaction.timestamp,
      input: transaction.input,
      value: transaction.value,
    }))
  } catch (error) {
    if (
      error instanceof Error &&
      error.message.includes('No transactions found')
    ) {
      return []
    }
    throw error
  }
}
